export default "__VITE_ASSET__DC7xwLRa__"